import { Router, ActivatedRoute, ActivatedRouteSnapshot } from '@angular/router';
import { Component, OnInit, AfterViewInit, Output, EventEmitter, ViewChild, ElementRef, OnDestroy } from '@angular/core';
// import { trigger, state, style, transition, animate } from '@angular/animations';
import { AccountService } from '../../../services/account.service';
import { AuthService } from '../../../services/auth/auth.service';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { LoginViewModel } from '../../../models/login-view-model';
import { AuthResponse } from '../../../models/auth-response';
// import { PushNotificationsService } from 'ng-push';
// import { NgProgress } from '@ngx-progressbar/core';
import { ConfirmationPageSuccessComponent } from '../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { ConfirmationPageFailComponent } from '../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
import { BusyIndicatorComponent } from '../../../shared-components/busy-indicator/busy-indicator.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalComponent } from '../../../shared-components/modal/modal.component';
import { DataService } from '../../../services/data.service';
import { ContractService } from '../../../services/contract.service';
import { LoginResult } from '../../../models/LoginResult';
import { PARAMETERS } from '@angular/core/src/util/decorators';
//import { Cookie } from 'ng2-cookies/ng2-cookies';

import * as Cookie from 'js-cookie';
import { UserDisplayInfo } from '../../../models/UserDisplayInfo';
import { UniversalloginComponent } from './universallogin/universallogin.component';
import { Jsonp } from '@angular/http';



// https://github.com/flauc/ng-push
// https://github.com/MurhafSousli/ngx-progressbar/blob/master/README_V3.md

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnDestroy, OnInit, AfterViewInit {

  @ViewChild('modal1') modal1: ModalComponent;
  @ViewChild('privacy1') privacy1: ModalComponent;
  @ViewChild('portalSelection') portalSelection: ModalComponent;
  @ViewChild('chatOffline') modal2: ModalComponent;
  @ViewChild('btnAccept') btnAccept: ElementRef;
  @ViewChild('btnReject') btnReject: ElementRef;
  @ViewChild('templateUniversalLogin') templateUniversalLogin: ModalComponent;
  @ViewChild('templateMyjssiPopup') templateMyjssiPopup: ModalComponent;
  @ViewChild('UniversalLogin') UniversalLogin: UniversalloginComponent;
  showSuccessConfirmation = false;
  public liveAgentId = '57360000000Kyxu';
  public env = 'Test';
  public isAnnualMeeting = false;
  // submitSuccessDescription = '';

  showFailConfirmation = false;
  loginFailDescription = '';

  loginType = '';
  user: LoginViewModel;
  authResponse: AuthResponse;
  allianceUrl: string;
  ampUrl: string;
  encUserName: string;
  encPassword: string;
  loginResponse: any;
  oldMyJSSIUrl: string;
  isOldVAMEnabled: boolean;
  termsOfUse = '';
  privacyPolicy = '';
  // private subscription: Subscription;
  private alive = true;
  currentIndex = 0;
  speed = 5000;
  infinite = true;
  autoplay = true;
  avatars: any[];
  carouselHeight = '260px';
  carouselWidth = '100%';
  userguid: string;
  token: string;
  LID: string;
  confirmEmailToken: string;
  transienturl: boolean;
  isimpersonate: boolean;
  vendorredirect: boolean =false;
  subHeaderLogo = 1;
  constructor(private _accountSerivce: AccountService,
    private _authService: AuthService,
    private _contractService: ContractService,
    private _router: Router,
    private _route: ActivatedRoute,
    // private _pushNotice: PushNotificationsService,
    // public progress: NgProgress,
    private _spinner: NgxSpinnerService,
    private _dataService: DataService,
  ) {
    //  _pushNotice.requestPermission();
    this.user = { username: '', password: '' };
    const reqUrl = this._router.url;
    this.transienturl = false;
    if (reqUrl.indexOf('transient') > -1) {
      this.transienturl = true;
    }

    this._route.queryParams
      .takeWhile(() => this.alive)
      .subscribe(params => {
        this.showFailConfirmation = false;
        this.showSuccessConfirmation = false;
        if (params['type']) {
          this.loginType = params.type;
        }
        if (params['impersonate']) {
          this.isimpersonate = true;
        }
        if (params['page'] ) {
          if (params['page'] === 'vendor') {
          this.vendorredirect = true;

          }
        }
        if (params['errorMsg']) {
          console.log(params);
          this.loginFailDescription = params.errorMsg;
          this.showFailConfirmation = true;
          this.showSuccessConfirmation = false;

          if (params.errorMsg.indexOf('You are not authorized to access this page') > -1) {
            // this._router.navigate(['/pages/login']);

            // this.templateMyjssiPopup.show();
          }
        } else if (params['u'] && params['p']) {
          this.encUserName = params['u'];
          this.encPassword = params['p'];
        } else if (params['userguid'] && params['token']) {
          this.userguid = params['userguid'];
          this.token = params['token'];
        } else if (params['id'] && params['userguid'] && params['ConfirmEmail']) {
          this.userguid = params['userguid'];
          this.confirmEmailToken = params['ConfirmEmail'];
          this.LID = params['id'];

        }
      });
  }
  onOpenModal() {
    this.templateUniversalLogin.data = this._dataService.userDisplayInfo.UniversalEmail;
    this._spinner.hide();
    this.templateUniversalLogin.show();
    // this.templateAddContract.show();
  }
  ngOnInit() {
    // this._authService.logOut();
    // if (this._authService.loggedIn()) {
    //  this._router.navigate(['/pages/client/my-contracts']);
    // }
    this._dataService.userDisplayInfo = null;
    this.avatars = [
      { url: '../../../../assets/img/MyJSSI Hero-1.jpeg', isDark: false, title: 'JSSI PreLaunch' }];
    if (this.encUserName && this.encPassword) {
      this.loginfallthrough(this.encUserName, this.encPassword);
    }
    if (this.userguid && this.token) {

      this.transient();
    }
    if (this.userguid && this.confirmEmailToken && this.LID) {
      this.ConfirmEmail();
    }


    // if (this._route.queryParams('errorMsg')) {
    //   this.loginFailDescription = this._route.snapshot.queryParams.get('errorMsg');
    //   this.showFailConfirmation = true;
    //   this.showSuccessConfirmation = false;
    // } else {
    // this.showFailConfirmation = false;
    // this.showSuccessConfirmation = false;
    // }
  }

  async ngAfterViewInit() {
    if (this.btnAccept.nativeElement) {
      console.log('inside accept');
      this.btnAccept.nativeElement.addEventListener('click', this.onAccept.bind(this));
    }
    if (this.btnReject.nativeElement) {
      console.log('inside reject');
      this.btnReject.nativeElement.addEventListener('click', this.onReject.bind(this));
    }
    this.liveAgentId = await this._accountSerivce.getLiveChatAgentId();
    this.env = await this._accountSerivce.getLiveChatEnvironment();
    console.log('Env: ' + this.env);
    const lsUrls = await this._accountSerivce.getLoginPageUrls();
    this.ampUrl = lsUrls[0];
    this.allianceUrl = lsUrls[1];
    this.oldMyJSSIUrl = lsUrls[2];
    if (lsUrls[3] === 'True') {
      this.isOldVAMEnabled = true;
    }
    this.termsOfUse = await this._accountSerivce.getHtmlFile('terms');
    this.privacyPolicy = await this._accountSerivce.getHtmlFile('privacy');
    const keyValue = await this._accountSerivce.getIsAnnualMeetingKey();
    if (keyValue === 'True') {
      this.isAnnualMeeting = true;
    }
    await this.initializeLiveChartScript();
  }

  private initializeLiveChartScript() {
    return new Promise((resolve, reject) => {
      if (document.getElementById('scrChat')) {
        document.getElementById('scrChat').remove();
      }

      if (document.getElementById('scrChatMyJSSI')) {
        document.getElementById('scrChatMyJSSI').remove();
      }
      const scriptTag = document.createElement('script');
      scriptTag.id = 'scrChat';
      scriptTag.type = 'text/javascript';
      scriptTag.innerHTML = 'initJSSIChat("' + this.env + '")';
      document.body.appendChild(scriptTag);
    });
  }

  login() {
    this._spinner.show();
    this._accountSerivce.login(this.user)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log('login data', data);
          this.loginResponse = data;
          if (!data.loginResult.IsAMPUser && !data.loginResult.IsAllianceUser && !(data.loginResult.UserTypeID === 3)) {
            // Need to remove this After Vendor Live
            this.afterLoginProcessing(data);
          } else if (data.loginResult.IsAMPUser && !data.loginResult.IsAllianceUser && data.loginResult.UserTypeID <= 0) {
            this.redirectToAMP();
          } else if (!data.loginResult.IsAMPUser && data.loginResult.IsAllianceUser && data.loginResult.UserTypeID <= 0) {
            this.redirectToAlliance();
          } else {
            this._spinner.hide();
            this.portalSelection.show();
          }
        },
        err => {
          this.showErrorConfirmation(err);

          // Notification
          // this._pushNotice.create(
          //   'Login failed!',
          //   { body: 'Not valid' }
          // )
          //   .subscribe(res => {
          //     if (res.event.type === 'click') {
          //       // You can do anything else here
          //       res.notification.close();
          //     }
          //   }
          // );

        },
        () => console.log('Request Complete')
      );
  }

  onAccept(event) {
    console.log('inside accept');
    this.privacy1.hide();
    this._spinner.show();
    // update privacy date
    this._accountSerivce.updatePrivacyDate()
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
        },
        err => {
          this._authService.logOut();
          this.showErrorConfirmation(err);
        },
        () => {
          console.log('Request Complete');
          this.getContracts();
          this._spinner.hide();
        }
      );
  }

  onReject(event) {
    console.log('inside reject');

    this.privacy1.hide();
    this._authService.logOut();
  }

  loginfallthrough(encrytUserName: string, encrytPassword: string) {
    // this._accountSerivce.loginFallThrough('KBaiGFv3oMGHqZzpe7KPCg==', 'vPK6mMGEULJfMALCvi67Zw==')
    this._spinner.show();
    this._accountSerivce.loginFallThrough(encrytUserName, encrytPassword)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log(data);
          this.loginResponse = data;
          // Clear Encrypted usermae before saving to localstorage
          data.loginResult.EncUserName = null;
          data.loginResult.EncPassword = null;

          // Need to Remove this after VAM Live
          if (this.loginType === 'customer' && data.loginResult.UserTypeID === 3) {
            this.loginResponse.loginResult.UserTypeID = 1;
            this.afterLoginProcessing(this.loginResponse);
          }

          if (!data.loginResult.IsAMPUser && !data.loginResult.IsAllianceUser && !(data.loginResult.UserTypeID === 3)) {
            this.afterLoginProcessing(data);
          } else if (data.loginResult.IsAMPUser && !data.loginResult.IsAllianceUser && data.loginResult.UserTypeID <= 0) {
            this.redirectToAMP();
          } else if (!data.loginResult.IsAMPUser && data.loginResult.IsAllianceUser && data.loginResult.UserTypeID <= 0) {
            this.redirectToAlliance();
          } else {
            this._spinner.hide();
            this.portalSelection.show();
          }
        },
        err => {
          this.showErrorConfirmation(err);
        },
        () => console.log('Request Complete')
      );
  }
  ConfirmEmail() {
    this._spinner.show();
    this._authService.authenticateConfrimEmailUser(this.userguid,
      this.confirmEmailToken,
      this.LID
    )
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log(data);
          this.loginResponse = data;
          if (!data.loginResult.IsAMPUser && !data.loginResult.IsAllianceUser && !(data.loginResult.UserTypeID === 3)) {
            // Need to remove this After Vendor Live

            this.afterLoginProcessing(data);
          } else if (data.loginResult.IsAMPUser && !data.loginResult.IsAllianceUser && data.loginResult.UserTypeID <= 0) {
            this.redirectToAMP();
          } else if (!data.loginResult.IsAMPUser && data.loginResult.IsAllianceUser && data.loginResult.UserTypeID <= 0) {
            this.redirectToAlliance();
          } else {
            this._spinner.hide();
            this.portalSelection.show();
          }
        },
        error => {
          // alert('error' + error);
          console.log(error);
          this.showErrorConfirmation(error);
        }

      );

  }
  transient() {


    const  userdisplayinfo = localStorage.getItem('displayUserInfo');
    if (userdisplayinfo) {
    this._dataService.userDisplayInfo = JSON.parse(userdisplayinfo);

    }
    let crmEmail = '';
    let crmFirstName = '';
    let crmLastName = '';
    console.log(userdisplayinfo);
    console.log(this._dataService.userDisplayInfo);
     if (this._dataService.userDisplayInfo) {
       crmEmail = this._dataService.userDisplayInfo.Email;
       crmFirstName =  this._dataService.userDisplayInfo.FirstName;
       crmLastName =  this._dataService.userDisplayInfo.LastName;

     }
    this._authService.authenticateTransientUser(this.userguid,
      this.token , this.isimpersonate, crmEmail,
     crmFirstName,
      crmLastName
    )
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          console.log(data);

          this.loginResponse = data;

          if ( data === null || data.loginResult.LID === '0') {
            this._spinner.hide();
              this.templateMyjssiPopup.show();
              return;
          }

          this._spinner.show();
          // user impersonate
          if (this.transient && this.isimpersonate) {
            data.UserTypeID = 5;
            data.loginResult.id = '';
          } else
           if (this.transient && this.vendorredirect) {
            data.loginResult.UserTypeID = 2;
          } else {
            data.loginResult.UserTypeID = 1;
          }

          if (!data.loginResult.IsAMPUser && !data.loginResult.IsAllianceUser && !(data.loginResult.UserTypeID === 3)) {
            // Need to remove this After Vendor Live

            this.afterLoginProcessing(data);
          } else if (data.loginResult.IsAMPUser && !data.loginResult.IsAllianceUser && data.loginResult.UserTypeID <= 0) {
            this.redirectToAMP();
          } else if (!data.loginResult.IsAMPUser && data.loginResult.IsAllianceUser && data.loginResult.UserTypeID <= 0) {
            this.redirectToAlliance();
          } else {
            this._spinner.hide();
            this.portalSelection.show();
          }
        },
        error => {
          // alert('error' + error);
          console.log(error);
          if (error.errorMsg.indexOf('You are not authorized to access this page') > -1)  {
            this.templateMyjssiPopup.show();
          } else {
          this.showErrorConfirmation(error);
          }
        }

      );
  }

  redirectToAMP() {
    if (this.encUserName) {
      this.postExternalUrl(this.ampUrl,  this.encUserName, this.encPassword);
    } else {
      this.postExternalUrl(this.ampUrl,  this.loginResponse.loginResult.EncUserName,
        this.loginResponse.loginResult.EncPassword);
    }
  }

  redirectToAlliance() {
    if (this.encUserName) {
      this.postExternalUrl(this.allianceUrl,  this.encUserName, this.encPassword);
    } else {
      this.postExternalUrl(this.allianceUrl,  this.loginResponse.loginResult.EncUserName,
      this.loginResponse.loginResult.EncPassword);
    }
  }

  postExternalUrl(url: string, username: string, password: string) {
    const mapForm = document.createElement('form');
    mapForm.target = '_self';
    mapForm.method = 'POST';
    mapForm.action = url;
    const inputUser = document.createElement('input');
    inputUser.type = 'hidden';
    inputUser.name = 'Username';
    inputUser.setAttribute('value', username);
    mapForm.appendChild(inputUser);
    const inputPass = document.createElement('input');
    inputPass.type = 'hidden';
    inputPass.name = 'Password';
    inputPass.setAttribute('value', password);
    mapForm.appendChild(inputPass);
    document.body.appendChild(mapForm);
    mapForm.submit();
  }

  redirectToCustomer() {
    this.portalSelection.hide();

    this.loginResponse.loginResult.UserTypeID = 1;
    this._spinner.show();
    this.afterLoginProcessing(this.loginResponse);
  }

  redirectToVendor() {
    this.portalSelection.hide();
    this.loginResponse.loginResult.UserTypeID = 2;
    this._spinner.show();
    this.afterLoginProcessing(this.loginResponse);
  }

  afterLoginProcessing(data) {

    // Clear Encrypted usermae before saving to localstorage
    data.loginResult.EncUserName = null;
    data.loginResult.EncPassword = null;
    const isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);

    if (isIEOrEdge) {
      Cookie.set('token', data.token);
      // alert(isIEOrEdge + ' token set in cookie:' + data.token);
    } else {
      localStorage.clear();
      localStorage.setItem('token', data.token);
    }

    const logined = this._authService.loggedIn();

    if (logined === true) {

      this._dataService.userDisplayInfo = null;
      //    console.log('data after logined', data);
      this._dataService.userDisplayInfo = data.loginResult;
      //    console.log(' this._dataService.userDisplayInfo after logined' + JSON.stringify(data.loginResult));
      if (isIEOrEdge) {

        // alert('got displayUserInfo' + JSON.stringify(data.loginResult));
        Cookie.set('displayUserInfo', JSON.stringify(data.loginResult));
      } else {
        localStorage.setItem('displayUserInfo', JSON.stringify(data.loginResult));
      }

      this._contractService.contracts = null;
      this._contractService.selectedContract = null;
      this._contractService.selectedContractNumber = '';


      // alert('this._dataService.userDisplayInfo ' + JSON.stringify(this._dataService.userDisplayInfo));
      if (!this._dataService.userDisplayInfo.IsPrivacyPolicyAccepted && this._dataService.userDisplayInfo.UserTypeID !== 5
         && this._dataService.userDisplayInfo.CompanyName !== ''

         && !this.transient) {
        this._spinner.hide();
        this.privacy1.show();
      } else {
        //  this._router.navigate(['/pages/MYJSSI-Bundle']);
        this.getContracts();
      }

    } else {
      alert('invalid token');
    }
  }

  getContracts() {
    if ((this._dataService.userDisplayInfo.id === null || this._dataService.userDisplayInfo.id === '')
      && this._dataService.userDisplayInfo.UserTypeID !== 5) {
      this.onOpenModal();
      return;
    }
    this._contractService.getContractList()
      .takeWhile(() => this.alive)
      .subscribe(
        contracts => {
          console.log('User contracts loaded initially');
        },
        err => {
          this._spinner.hide();
          this.showErrorConfirmation(err);
          console.log('Encountering error while getContractList: ' + err);
        },
        () => {
          this._spinner.hide();
          // Redirect to the initial requestUrl before login
          if (this._authService.redirectUrl) {
            this._router.navigateByUrl(this._authService.redirectUrl);
          } else {
            console.log('this._dataService.userDisplayInfo ' + JSON.stringify(this._dataService.userDisplayInfo));
            switch (this._dataService.userDisplayInfo.UserTypeID) {
              case 1:
              case 3:
                console.log('user role 1 or 3');
                this._router.navigate(['/pages/client/my-contracts']);
                // this._router.navigate(['/pages/MYJSSI-Bundle']);
                break;

              case 2:
                console.log('user role 2', this._dataService.userDisplayInfo.UserTypeID);
                this._router.navigate(['/pages/vendor/myvendor']);
                break;

              case 4:
                this._router.navigate(['/pages/vendor/myvendor']);
                break;

              case 5:
                this._router.navigate(['/pages/client/searchcontracts']);
                break;

              default:
                console.log('user role default');
                this._router.navigate(['/pages/client/my-contracts']);
            }

            // this._router.navigate(['/pages/client/my-contracts']);
          }
        }
      );
  }

  showErrorConfirmation(err) {
    this._spinner.hide();
    console.log('Log in failed.');
    console.log(err);


    this.showFailConfirmation = true;
    this.showSuccessConfirmation = false;
    this.loginFailDescription = err._body;


  }

  forgotPwd() {
    this._router.navigate(['/forgot-password']);
  }

  // goToMyContract(event) {
  //   this._router.navigate(['/pages/client/my-contracts']);
  // }

  // goToSomewhereElse(event) {
  //   // Redirect to the initial requestUrl before login
  //   if (this._authService.redirectUrl) {
  //     this._router.navigateByUrl(this._authService.redirectUrl);
  //   } else {
  //     this._router.navigate(['/pages/client/my-contracts']);
  //   }
  // }

  closeConfirmation(event) {
    if (this.encUserName && !this.user && !this.user.username) {
      this._router.navigate(['/pages/login']);
    } else {
      this.showSuccessConfirmation = false;
      this.showFailConfirmation = false;
      this.encUserName = null;
      this.encPassword = null;
    }
  }

  retryLogin(event) {
    if (this.encUserName && !this.user && !this.user.username) {
      this._router.navigate(['/pages/login']);
    } else {
      this.showSuccessConfirmation = false;
      this.showFailConfirmation = false;
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }
  onChangeSubStep($event) {
    this.subHeaderLogo = $event;
    console.log($event);
    const category = $event as number;
    switch (category) {
      case 1:
        this.subHeaderLogo = 1;
        break;
      case 2:
        this.subHeaderLogo = 2;
        break;
      case 3:
        this.subHeaderLogo = 3;
        break;
      case 4:
        this.subHeaderLogo = 4;
        break;
      case 5:
        this.subHeaderLogo = 5;
        break;
      default:
        this.subHeaderLogo = 1;
        break;
    }
  }
  onCloseModal($event) {
    if (this._authService.redirectUrl) {
      this._router.navigateByUrl(this._authService.redirectUrl);
    } else {
      switch (this._dataService.userDisplayInfo.UserTypeID) {
        case 1:
        case 3:
          console.log('user role 1 or 3');
          this._router.navigate(['/pages/client/my-contracts']);
          // this._router.navigate(['/pages/MYJSSI-Bundle']);
          break;
        case 2:
          console.log('user role 2', this._dataService.userDisplayInfo.UserTypeID);

          this._router.navigate(['/pages/vendor/myvendor']);
          break;

        case 4:
          this._router.navigate(['/pages/vendor/myvendor']);
          break;

        case 5:
          this._router.navigate(['/pages/client/searchcontracts']);
          break;

        default:
          console.log('user role default');
          this._router.navigate(['/pages/client/my-contracts']);
      }
      this.templateUniversalLogin.hide();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/account/login/login.component.ts